import React from 'react';

import { useAccount } from '~/apis/apiAccount';

import ProfilePicture from './ProfilePicture';

interface AccountProfilePictureProps {
  username: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const AccountProfilePicture: React.FC<AccountProfilePictureProps> = ({
  username,
  size = 'md',
  className,
}) => {
  const { data: account } = useAccount();

  return (
    <ProfilePicture
      username={username}
      size={size}
      className={className}
      profilePicture={account?.profilePicture || undefined}
    />
  );
};

export default AccountProfilePicture;
